import "./style.css";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../redux/reducers/alert";
import { deleteSchool, getAllSchools, searchSchools } from "../../api/schools";
import { ManagementTable } from "../../components/managementTable";
import { TableHeader } from "./components";
import { AddSchoolDialog } from "../../components/dialogs";
import { StudentConfirmationDeleteDialog } from "../../components/dialogs/studentConfirmationDeleteDialog";

export const SchoolManagement = () => {
  const { t } = useTranslation();
  const [schools, setSchools] = useState([]);
  const [isPreAddDialogVisible, setIsPreAddDialogVisible] = useState(false);
  const [isAddSchoolDialogVisible, setIsAddSchoolDialogVisible] =
    useState(false);
  const [loading, setLoading] = useState(true);
  const [isEditedItem, setIsEditedItem] = useState(null);
  const [
    isConfirmationDeleteDialogVisible,
    setIsConfirmationDeleteDialogVisible,
  ] = useState(false);
  const [rowSelectedId, setRowSelectedId] = useState(null);

  const [selectedIds, setSelectedIds] = useState([]);
  const [SearchValue, setSearchValue] = useState("");
  const { token, role, id, schoolId } = useSelector((state) => state.user);
  const closePreAddDialog = () => setIsPreAddDialogVisible(false);
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  const openAddSchoolDialog = () => {
    closePreAddDialog();
    setIsAddSchoolDialogVisible(true);
  };
  const closeAddSchoolDialog = () => {
    setIsAddSchoolDialogVisible(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const dispatch = useDispatch();
  const history = useHistory();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const handleSelection = (ids) => setSelectedIds(ids);

  const successCallback = async () => {
    closeAddSchoolDialog();
    fetchSchools();

    setIsEditedItem(null);
  };

  const deleteCallback = async () => {
    fetchSchools();
    setSelectedIds(false);
  };
  const fetchSchools = async () => {
    try {
      const payload = {
        role,
        id,
        schoolId,
      };
      const response = await getAllSchools(payload, token);
      if (response.status) {
        setSchools(response?.schools);
      } else {
        showErrorAlert(response?.message);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      showErrorAlert(e || e.message || t("text_something_went_wrong_try_again_later"));
    }
  };

  useEffect(() => {
    if (SearchValue === "") {
      fetchSchools();
    } else {
      (async () => {
        setLoading(true);
        try {
          setSchools([]);
          const payload = {
            role,
            id,
            schoolId,
          };
          const response = await searchSchools(payload, SearchValue, token);
          if (response.status) {
            setSchools(response?.schools);
            if (response.schools.length === 0) {
              showErrorAlert(t("text_records_not_found"));
            }
          }
          setLoading(false);
        } catch (e) {
          showErrorAlert(e.message || t("text_error_in_searching_schools"));
          setLoading(false);
        }
      })();
    }
  }, [SearchValue]);
  const handleSearching = (e) => {
    setSearchValue(e);
  };
  const deleteItem = async () => {
    try {
      await deleteSchool(rowSelectedId, token);
      local.push({
        message: t("text_school_deleted_successfully"),
        date: new Date().getTime(),
        newNotification: true,
      });
      localStorage.setItem("notify", JSON.stringify(local));
      setIsConfirmationDeleteDialogVisible(false);
      deleteCallback();
    } catch (err) {
      showErrorAlert(
        err.message || t("text_error_in_deleting_school_please_try_again")
      );
    }
  };
  const handleCancel = () => {
    setIsConfirmationDeleteDialogVisible(false);
  };
  const editSchool = (item) => {
    setIsEditedItem(item);
    setIsAddSchoolDialogVisible(true);
  };

  const editSuccessCallback = async (item) => {
    const updatedSchools = schools.map((schoolItem) => {
      if (schoolItem.id === item.id) {
        return item;
      } else return schoolItem;
    });
    closeAddSchoolDialog();
    setSchools(updatedSchools);
  };
  const viewItem = async (id) => history.push({
    pathname: `/schools/schools-detail/${id}`,
    state: {
      schools: schools,
    },
  });

  const SCHOLL_MANAGMENT_COLUMNS = [
    { id: "id", numeric: false, disablePadding: true, label: t("text_school_id") },
    { id: "merchantId", numeric: false, disablePadding: true, label: t("text_merchant_id"), },
    { id: "address", numeric: false, disablePadding: true, label: t("text_payee_type") },
    { id: "name", numeric: false, disablePadding: true, label: t("text_name") },
    { id: "vat", numeric: false, disablePadding: true, label: t("text_vat") },
    {id: "paynestFee",numeric: false,disablePadding: true,label: t("text_paynest_fee"), },
    { id: "actions", numeric: false, disablePadding: true, label: "" },
  ];

  return (
    <div className="school-management-page">
      <h3>
        <strong style={{ fontWeight: "600" }}>{t("text_school_management")}</strong>
      </h3>

      <div className={"school-management-container"}>
        <TableHeader
          searchValue={handleSearching}
          handleAdd={openAddSchoolDialog}
          selectedIds={selectedIds}
          deleteCallback={deleteCallback}
        />

        {loading ? (
          <div className={"school-loader"}>
            <CircularProgress size={20} style={{ color: "black" }} />
            {t("text_fetching_schools_data")}
          </div>
        ) : (
          <ManagementTable
            handleSelection={handleSelection}
            data={schools}
            columns={SCHOLL_MANAGMENT_COLUMNS}
            deleteItem={deleteItem}
            editItem={editSchool}
            isConfirmationDeleteDialogVisible={
              isConfirmationDeleteDialogVisible
            }
            setIsConfirmationDeleteDialogVisible={
              setIsConfirmationDeleteDialogVisible
            }
            setRowSelectedId={setRowSelectedId}
            viewItem={viewItem}
          />
        )}
      </div>
      {/*changing in school field and dialog open.*/}
      {isAddSchoolDialogVisible && (
        <AddSchoolDialog
          title={isEditedItem ? t("text_edit_school") : t("text_add_school")}
          handleClose={closeAddSchoolDialog}
          open={isAddSchoolDialogVisible}
          successCallback={successCallback}
          isEditedItem={isEditedItem}
          editSuccessCallback={editSuccessCallback}
        // handleClose={closePreAddDialog}
        // open={isPreAddDialogVisible}
        />
      )}
      {isConfirmationDeleteDialogVisible && (
        <StudentConfirmationDeleteDialog
          open={isConfirmationDeleteDialogVisible}
          close={handleCancel}
          title={t("text_school")}
          handleDelete={deleteItem}
        />
      )}
    </div>
  );
};
